module.exports = __webpack_public_path__ + "img/infographic.6f1780cc.png";